const DefaultValues = {
    limit: 25,
};
export default DefaultValues;
